import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslate } from '../../mixins/translate/translate';
import { openApiFetchDelete, openApiFetchGet } from '../../store/openApiFetch';
import { IconButton } from '../common/iconButtons/IconButton';
import { IconEditButton } from '../common/iconButtons/IconEditButton';
import { IconRemoveButton } from '../common/iconButtons/IconRemoveButton';
import {
    Content,
    Panel,
    PanelBody,
    PanelRouterLink,
    Table,
    TableBody,
    TableButtons,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../elements';
import { Spinner } from '../spinners';
import { useReactAsync } from '../utils/useReactAsync';

async function loadEquipmentTypes() {
    const result = await openApiFetchGet('/api/equipmentTypes', {});
    return result;
}

export function EquipmentTypesList() {
    const translate = useTranslate();
    const { data, reload, isLoading } = useReactAsync(loadEquipmentTypes, {}, []);
    const navigate = useNavigate();

    async function removeEquipmentType(equipmentTypeId: string) {
        await openApiFetchDelete('/api/equipmentTypes/{equipmentTypeId}', { equipmentTypeId });
        await reload();
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title={translate('equipment.types')} icon="fa-cogs" />
                </TopbarLeft>
                <TopbarRight>
                    <PanelRouterLink
                        to="/settings/equipmenttypes/add"
                        text={translate('common.addItem', translate('equipment.types'))}
                        icon="fa fa-plus"
                        small={true}
                    />
                </TopbarRight>
            </Topbar>

            <Content>
                <Tray>
                    <Panel>
                        {(isLoading && <Spinner />) || (
                            <PanelBody noPadding={true}>
                                <Table>
                                    <TableHead>
                                        <TableHeadRow light={true}>
                                            <TableHeader>{translate('common.name')}</TableHeader>
                                            <TableHeader>&nbsp;</TableHeader>
                                        </TableHeadRow>
                                    </TableHead>
                                    <TableBody>
                                        {data &&
                                            data.map((item) => (
                                                <TableRow key={item.id}>
                                                    <TableData> {item.name} </TableData>
                                                    <TableButtons large>
                                                        <IconButton
                                                            iconClass="fa-list"
                                                            onClick={() => navigate(`/settings/equipmenttypes/${item.id}/fields`)}
                                                            title={translate('equipment.customFields')}
                                                        />
                                                        <IconEditButton onClick={() => navigate(`/settings/equipmenttypes/${item.id}/edit`)} />
                                                        <IconRemoveButton
                                                            removeQuestion={translate('common.confirmDelete', item.name)}
                                                            onClick={async () => removeEquipmentType(item.id)}
                                                        />
                                                    </TableButtons>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </PanelBody>
                        )}
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
